import React from "react";
import { faExpand } from "@fortawesome/fontawesome-free-solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const ExpandIcon = () => {
  return <FontAwesomeIcon icon={faExpand} width="20" height="20" />;
};
